import React from 'react';
import { Query } from '@apollo/client/react/components';
import { Button } from 'react-bootstrap';
import { auditBarcodesQuery } from '../../api';
import { transferAuditColumns } from '../../utils';
import ReactTable from 'react-table';
import SlidingPane from 'react-sliding-pane';
import { ErrorMessage } from '../../../../components/ErrorMessage';
import { Loader } from '../../../../components/Loader';

export const TransferTimelineModal = (props: any) => {
  const [visible, setVisible] = React.useState(false);

  return (
    <div style={{ textAlign: 'center' }}>
      <Button onClick={() => setVisible(true)} href=''>
        <i className='fa fa-external-link-alt'></i>
      </Button>
      <SlidingPane style={{ zIndex: 50 }} isOpen={visible} width='700px' title='Transfer Timeline' onRequestClose={() => setVisible(false)}>
        <Query query={auditBarcodesQuery} variables={{ barCode: props.barcode, type: 'Transfer' }}>
          {({ loading, error, data }: any) => {
            if (loading) return <Loader />;
            if (error) return <ErrorMessage title='Issue Finding Transfer Timeline Data' />;
            if (data) {
              return (
                <ReactTable
                  columns={transferAuditColumns}
                  pageSize={22}
                  showPagination={false}
                  sortable={false}
                  noDataText='No Data Available'
                  className='-striped -highlight mb-4'
                  data={data.readCommentsByBarcode}
                />
              );
            }
            return (
              <div>
                <h2>Null?</h2>
              </div>
            );
          }}
        </Query>
      </SlidingPane>
    </div>
  );
};
